import { GET } from "@/api/client";
import { TResponse } from "@/api/types";
import { useQuery } from "@tanstack/react-query";

export const useGetHospitalsResource = (searchText: string) => {
  return useQuery<TResponse<TransferRequest[]>>({
    queryKey: [`/transfer/requests/transferring`, searchText],
    queryFn: () =>
      GET(`/transfer/requests/transferring`, {
        // 로그인 기능 완성 후 제거
        hospitalCode: "A1300002",
        searchTitle: searchText,
      }),
  });
};

export interface TransferRequest {
  requestId: string;
  preKtas: 1 | 2 | 3 | 4 | 5;
  patientName: string;
  birthDt: string;
  chiefComplaint: string[];
  managerName: string;
  managerPhone: string;
  arrivalTime: string; // 또는 Date, 사용 용도에 따라 다름
  transferType: string;
  requiredResources: string[];
}
